import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarProvider } from '../ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { useApplyTheme } from '../../hooks/useApplyTheme';

interface LayoutProps {
  children: React.ReactNode;
}

function LayoutComponent({ children }: LayoutProps) {
  const location = useLocation();
  useApplyTheme();
  
  // Pages that need full-width layout without padding
  const fullWidthPages = ['/entities', '/signatories', '/kyc', '/bank-accounts', '/banks', '/users', '/mandate-history', '/mandates', '/workflows', '/ebam', '/reviews', '/settings', '/home', '/help'];
  const isFullWidth = fullWidthPages.some(page => location.pathname.startsWith(page)) || location.pathname === '/';
  
  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden bg-card">
        <AppSidebar />
        <div className="relative flex flex-1 flex-col min-w-0">
          {/* Main content */}
          <main className="flex-1 overflow-hidden bg-surface min-w-0">
            {isFullWidth ? (
              <div className="h-full flex flex-col min-w-0">
                {children}
              </div>
            ) : (
              <div className="h-full overflow-auto px-6 py-8">
                {children}
              </div>
            )}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}

export const Layout = memo(LayoutComponent);